import { api } from '../api'
import {
  ChargeIntentResponse,
  ChargeIntentErrorResponse,
  CreateChargeIntentRequestBody,
} from 'models/ChargeIntent'

// Note both of these are just works in progress to allow testing classypay's endpoint
// for integration purposes. Both need significant rework when implementing finalizePayment()
export const chargeIntentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createChargeIntent: builder.mutation<
      ChargeIntentResponse | ChargeIntentErrorResponse,
      { campaignId: string; paymentMethod: string; body: CreateChargeIntentRequestBody }
    >({
      query: ({ campaignId, paymentMethod, body }) => ({
        // We add the `payment_method` to the query param for observability and tracking purposes
        url: `/charge-intent?campaign_id=${campaignId}&payment_method=${paymentMethod}`,
        method: 'POST',
        body: body,
      }),
    }),
  }),
})

/**
 * Export the query hooks as well as the endpoints (for SSR).
 */
export const {
  endpoints: { createChargeIntent },
  useCreateChargeIntentMutation,
} = chargeIntentApi
